export const MAX_RECENTLY_PLAYED_GAMES = 6;
